var d = /* @__PURE__ */ ((s) => (s[s.Small = 0] = "Small", s[s.Medium = 1] = "Medium", s[s.Big = 2] = "Big", s))(d || {});
const g = {
  0: "p-2",
  1: "p-3",
  2: "p-10"
};
export {
  d as FileDropZoneVariantEnum,
  g as variantClassName
};
